import React, { useEffect, useContext } from "react";
import { Link, NavLink, useLocation, useParams } from "react-router-dom";

import * as Icon from "react-feather";
import caseManagementActive from "../../../assets/images/case-management.svg";
import caseManagementInactive from "../../../assets/images/case_management-inactive.svg";
import eligibilityActive from "../../../assets/images/eligibility.svg";
import eligibilityInactive from "../../../assets/images/eligibility-inactive.svg";
import impactActive from "../../../assets/images/impact.svg";
import impactInactive from "../../../assets/images/impact-inactive.svg";
import initiativesActive from "../../../assets/images/initiatives.svg";
import initiativesInactive from "../../../assets/images/initiatives-inactive.svg";
import detailsActive from "../../../assets/images/details-active.svg";
import detailsInactive from "../../../assets/images/details-inactive.svg";
import programsActive from "../../../assets/images/programs.svg";
import programsInactive from "../../../assets/images/programs-inactive.svg";
import referralsActive from "../../../assets/images/Referrals.svg";
import referralsInactive from "../../../assets/images/referrals-inactive.svg";
import referralFormsActive from "../../../assets/images/referral-form-active.svg";
import referralFormsInactive from "../../../assets/images/referral-form-inactive.svg";
import widgetsActive from "../../../assets/images/widgets-active.svg";
import widgetsInactive from "../../../assets/images/widgets-inactive.svg";
import styled from "styled-components";
import { P } from "../../atoms/Texts";

import { demoContext } from "../../../shared/store/contexts";

const DashboardAside = styled.aside`
  background: #ffffff;
  left: 0;
  top: 72px;
  width: 300px;
  // min-height: 100vh;
  height: calc(100vh - 72px);
`;

const NavLi = styled(NavLink)`
  & > div {
    background: transparent;
  }

  &.active > div,
  &:hover > div {
    background: #dcd6fe;
  }

  &.active > div {
    color: #442ed0;
  }
`;

const DashboardSideNav = () => {
  let location = useLocation();
  const { id } = useParams();

  const { organization } = useContext(demoContext);

  // const { getSpecificOrganization, specificOrganizationData } = useOrganization();

  // useEffect(() => {
  //   getSpecificOrganization(id);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [id]);

  return (
    <DashboardAside className="flex-shrink-0 px-6 py-8 sticky top-0 overflow-y-auto flex flex-col justify-between">
      <ul className="items-start">
        <NavLi
          to={`/dashboard/organization/${id}/impact-management`}
          isActive={(match, location) => {
            if (
              match ||
              [
                `/dashboard/organization/${id}/impact-management`,
                `/dashboard/organization/${id}`,
              ].includes(location.pathname)
            ) {
              return true;
            } else {
              return false;
            }
          }}
          activeClassName="active"
        >
          <div className="px-5 py-3 mb-4 flex items-center">
            <img
              src={
                location.pathname.includes(
                  `/dashboard/organization/${id}/impact-management`,
                ) || location.pathname === `/dashboard/organization/${id}`
                  ? impactActive
                  : impactInactive
              }
              alt="Impact"
              className="mr-3 h-5 w-5"
            />
            <P className="" fontSize="14px">
              Impact
            </P>
          </div>
        </NavLi>

        <NavLi
          to={`/dashboard/organization/${id}/programs`}
          activeClassName="active"
        >
          <div className="px-5 py-3 mb-4 flex items-center">
            <img
              src={
                location.pathname.includes(`/dashboard/organization/${id}/programs`)
                  ? programsActive
                  : programsInactive
              }
              alt="Services"
              className="mr-3 h-5 w-5"
            />
            <P fontSize="14px">Services</P>
          </div>
        </NavLi>

        <NavLi
          to={`/dashboard/organization/${id}/initiatives`}
          activeClassName="active"
        >
          <div className="px-5 py-3 mb-4 flex items-center">
            <img
              src={
                location.pathname.includes(
                  `/dashboard/organization/${id}/initiatives`,
                )
                  ? initiativesActive
                  : initiativesInactive
              }
              alt="Initiatives"
              className="mr-3 h-5 w-5"
            />
            <P fontSize="14px">Initiatives</P>
          </div>
        </NavLi>

        <NavLi
          to={`/dashboard/organization/${id}/referrals`}
          activeClassName="active"
        >
          <div className="px-5 py-3 mb-4 flex items-center">
            <img
              src={
                location.pathname.includes(`/dashboard/organization/${id}/referrals`)
                  ? referralsActive
                  : referralsInactive
              }
              alt="Referrals"
              className="mr-3 h-5 w-5"
            />
            <P fontSize="14px">Referrals</P>
          </div>
        </NavLi>
        <NavLi
          to={`/dashboard/organization/${id}/case-management`}
          activeClassName="active"
        >
          <div className="px-5 py-3 mb-4 flex items-center">
            <img
              src={
                location.pathname.includes(
                  `/dashboard/organization/${id}/case-management`,
                )
                  ? caseManagementActive
                  : caseManagementInactive
              }
              alt="Case management"
              className="mr-3 h-5 w-5"
            />
            <P fontSize="14px">Case management</P>
          </div>
        </NavLi>
        <NavLi
          to={`/dashboard/organization/${id}/eligibility`}
          activeClassName="active"
        >
          <div className="px-5 py-3 mb-4 flex items-center">
            <img
              src={
                location.pathname.includes(
                  `/dashboard/organization/${id}/eligibility`,
                )
                  ? eligibilityActive
                  : eligibilityInactive
              }
              alt="Eligibility"
              className="mr-3 h-5 w-5"
            />
            <P fontSize="14px">Eligibility</P>
          </div>
        </NavLi>
        <NavLi
          to={`/dashboard/organization/${id}/referral-forms`}
          activeClassName="active"
        >
          <div className="px-5 py-3 mb-4 flex items-center">
            <img
              src={
                location.pathname.includes(
                  `/dashboard/organization/${id}/referral-forms`,
                )
                  ? referralFormsActive
                  : referralFormsInactive
              }
              alt="Referral Forms"
              className="mr-3 h-5 w-5"
            />
            <P fontSize="14px">Referral Forms</P>
          </div>
        </NavLi>
        <NavLi to={`/dashboard/organization/${id}/widgets`} activeClassName="active">
          <div className="px-5 py-3 mb-4 flex items-center">
            <img
              src={
                location.pathname.includes(`/dashboard/organization/${id}/widgets`)
                  ? widgetsActive
                  : widgetsInactive
              }
              alt="Referral Forms"
              className="mr-3 h-5 w-5"
            />
            <P fontSize="14px">Widgets</P>
          </div>
        </NavLi>
        <NavLi
          to={`/dashboard/organization/${id}/organization-details`}
          activeClassName="active"
        >
          <div className="px-5 py-3 mb-4 flex items-center">
            <img
              src={
                location.pathname.includes(
                  `/dashboard/organization/${id}/organization-details`,
                )
                  ? detailsActive
                  : detailsInactive
              }
              alt="Details"
              className="mr-3 h-5 w-5"
            />
            <P fontSize="14px">Org Details</P>
          </div>
        </NavLi>
      </ul>
      <Link to={`/dashboard`}>
        <div
          className="flex items-center cursor-pointer ml-4"
          style={{
            width: "fit-content",
          }}
        >
          <Icon.ChevronLeft size={14} color="#7D7B96" className="mr-2" />
          <P color="#332ecf" fontSize="14px" smallSize="14px" fontFamily="semi">
            {organization.name}
          </P>
        </div>
      </Link>
    </DashboardAside>
  );
};

export default DashboardSideNav;
